/* istanbul ignore file */
export const WIDGET_SITE_LIST_TYPE = 'instance-list';
export const SITE_BLOCK_MIN_WIDTH = 96;
